import utils from './utils';
import config from '../config';

// リプロ実行状態を返却する 
// reproStatus : リプロ実行状態 
export const isRunningReprogram = (reproStatus) => {
    let result = false;
    if (reproStatus === 'failure' ||
        reproStatus === 'executing' ||
        reproStatus === 'executing_ig_off' ||
        reproStatus === 'executing_ig_on') {
        result = true;
    }
    return result;
};

// リプロの状態監視ポーリングが実行中かどうかを返却する
export const isRunningReproPolling = (reproStatus) => {
    let result = false;
    if (reproStatus === 'executing' ||
        reproStatus === 'executing_ig_off' ||
        reproStatus === 'executing_ig_on') {
        result = true;
    }
    return result;
};

// Menu画面のエラー判定
// リプログラミング画面の警告ダイアログ有無判定
// TYPE2のECUのIDが一方のみ取得された場合は、警告対象とする。
export const hasFailedStateUnit = (list, resources) => {
    const isFailedStatus = (status) => { return !status || status === 'error'; };
    // 搭載 / 通信 / リプロ有無 いずれかにおいてステータスが null or error のものがあれば警告表示対象
    const failedUnits = list.filter(e => {
        const reprogrammableInfo = [e.reprogrammable_info.normal.reprogrammable_status, e.reprogrammable_info.merchantability.reprogrammable_status, e.reprogrammable_info.restore.reprogrammable_status];
        const isReprogrammable = reprogrammableInfo.some(i => { return isFailedStatus(i); });
        return isReprogrammable || isFailedStatus(e.installation_status) || isFailedStatus(e.communication_status);
    });
    if (failedUnits.length === 0) {
        return false;
    }


    // 上記の条件に合致した ECU の内、非搭載のものおよび RKE/TPMS は警告表示の判定に不要
    const installedEcus = failedUnits.filter(ecu => {
        const isInstalled = ecu.installation_status === config.REPRO_INSTALLED;
        const targetEcu = resources.filter(e => e.id === ecu.id);
        const isIncluded = (name) => { return (name.indexOf('RKE_') > -1 || name.indexOf('TPMS_') > -1); };
        const isRkeOrTpms = (targetEcu.length > 0 && targetEcu[0].name) ? isIncluded(targetEcu[0].name) : false;
        return isInstalled && !isRkeOrTpms;
    });
    // CGW 管理対象外ユニットの判定排除
    if (installedEcus.length > 0) {
        const outOfCgw = ['FCR', 'FCR_L', 'FCR_R', 'BECM_CGW', 'DMCM_CGW', 'FCR_25ePF', 'FCR_R_25ePF', 'FCR_L_25ePF'];
        const isAllOutOfCgw = failedUnits.filter(e => {
            const targetEcu = resources.filter(ecu => e.id === ecu.id);
            const notEcuInstalled = e.installation_status === config.REPRO_NOT_INSTALLED;
            return targetEcu.length > 0 && outOfCgw.includes(targetEcu[0].name) && notEcuInstalled;
        });
        // 失敗したユニットの中で非搭載の管理外対象ユニットしかない場合は警告を表示しない
        if (installedEcus.length === isAllOutOfCgw.length) {
            return false;
        } else {
            // 長さが同じではない場合、CGW管理対象外ユニット以外にエラー状態がある
            return true;
        }
    } else {
        return false;
    }
};

// 以下の処理は現在使用していないが、今後使用する可能性があるのでコメントアウト
// function getDefinedKeyFromReproState(code) {
//     let sDefinedKey = '';
//     switch (code) {
//         case 'none':
//         case 'power_on':
//         case 'target_confirmation':
//         case 'car_status':
//         case 'extended_session2':
//         case 'extended_session':
//         case 'gw_authentication':
//         case 'diagnosis_stop':
//         case 'cycle_stop':
//         case 'gw_mode_change':
//         case 'communication_check':
//         case 'security_access':
//         case 'unit_status':
//         case 'repro_session':
//             sDefinedKey = 'status_repro_execute_pre_program';
//             break;

//         case 'rom_clear':
//         case 'data_download':
//         case 'data_transfer':
//         case 'data_send_complete':
//         case 'check_sum':
//             sDefinedKey = 'status_repro_execute_on_program';
//             break;

//         case 'ig_offon':
//         case 'power_on_after_repro':
//         case 'fingerprint':
//         case 'rewrite_confirmation':
//         case 'extended_session3':
//         case 'gw_authentication2':
//         case 'memory_clear':
//         case 'memory_clear2':
//         case 'repro_complete':
//             sDefinedKey = 'status_repro_execute_post_program';
//             break;
//         default:
//             //console.log(code);
//             break;
//     }

//     return sDefinedKey;
// }

export const calculateFileDownloadTime = (totalDownloadTime, initvalue = null) => {
    let result = initvalue;
    if (totalDownloadTime) {
        result = utils.timeSpanConverter(totalDownloadTime);
    }
    return result;
};

export const toFixedDownloadSpeed = (downloadSpeed, initvalue = null) => {
    let result = initvalue;
    if (downloadSpeed) {
        const tmp = Number(downloadSpeed.toFixed(2));
        result = Number.isNaN(tmp) ? initvalue : tmp;
    }
    return result;
};


export default {
    isRunningReprogram,
    isRunningReproPolling,
    calculateFileDownloadTime,
    toFixedDownloadSpeed,
    hasFailedStateUnit
};